import { useLazyQuery, useQuery } from "@apollo/client";
import { PRODUCT } from "../products.queries";
import {
  ProductQuery,
  ProductQueryVariables,
} from "../../../__generated__/ProductQuery";

export const useProduct = (id: number) => {
  return useQuery<ProductQuery, ProductQueryVariables>(PRODUCT, {
    variables: { id },
  });
};

export const useLazyProduct = () => {
  return useLazyQuery<ProductQuery, ProductQueryVariables>(PRODUCT);
};
